import Vue from 'vue';
import App from './App.vue';
//import librerias from './librerias.js';

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
